import React from "react";
import "./RentType.css";
import RentTypeLogo from "../../../assets/renttypelogo.png";

function RentType() {
  return (
    <div className="renttype-container">
      <div className="renttype-content">
        <a href="http://renttype.com" target="_blank" rel="noopener noreferrer">
          <div className="renttype-logo-container">
            <img
              src={RentTypeLogo}
              alt="RentType Logo"
              className="renttype-logo"
            />
          </div>
        </a>

        <div className="renttype-text-container">
          <h1 className="renttype-main-title">RentType.com</h1>
          <h2 className="renttype-second-title">
            Unlocking Adventures, Redefining Mobility
          </h2>
          <p className="renttype-descriptions">
            Embark on an extraordinary journey with RentType.com, a global stage
            where mobility isn't merely a feature; it's a lifestyle. Envision a
            platform where vehicle rentals transform into boundless expeditions,
            where every car, van, and road unfurls as a tapestry of
            possibilities. Our interface isn't just user-friendly; it's an ode
            to the future of convenience. The meticulously curated array of
            vehicles, coupled with the seamless user experience, metamorphoses
            RentType.com into an artist's canvas where journeys are crafted with
            meticulous care. At RentType.com, trust isn't just the destination;
            it's the vehicle that transcends mere locations, ushering you into a
            realm of unforgettable experiences.
            <br />
            <br />
            • An intuitive platform designed for both advertising and renting
            vehicles.
            <br />
            • A comprehensive spectrum of short-term and long-term vehicle
            rental options.
            <br />
            • A diverse selection of vehicles available for rent worldwide.
            <br />• A location-based search and booking system designed for
            ultimate convenience.
          </p>
        </div>
      </div>
    </div>
  );
}

export default RentType;
